import { Features } from '../constants/features';
import { useIsSellerFeatureEnabled } from '../hooks/use-is-seller-feature-enabled';

export const useOrderRoutingFeatureGate = (): boolean => useIsSellerFeatureEnabled(Features.OrderRouting);
